import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const initialState = {
  sidebar: {
    open: false
  },
  bpSelectionDialog: {
    display: false
  },
  overrideThemeBpsDialog: {
    display: false
  }
};

export default {
  namespaced: false,
  state: { ...initialState },
  mutations,
  actions,
  getters
};
